import type sv from '../sv/meetings'

const meetings: typeof sv = {
  calendar: {
    loading: 'Loading calendar...',
    today: 'Today',
    previous: 'Previous',
    next: 'Next',
    week: 'Week',
    month: 'Month',
    activity: 'Activity',
    inviteHub: 'Invite HUB',
    more_one: '+{{count}} more',
    more_other: '+{{count}} more',
    activitiesAt_one: '{{count}} activity at {{hour}}',
    activitiesAt_other: '{{count}} activities at {{hour}}',
  },
  hub: {
    start: 'Start meeting',
    starting: 'Starting meeting…',
    startTitle: 'Start a meeting now',
    startDescription:
      'Pick the language spoken in the meeting. HUB transcribes and writes the notes in it.',
    live: 'Live',
    liveBadge: '● Live',
    join: 'Join the meeting',
    notConfigured: 'Video meetings are not configured in this environment.',
    startFailed: 'Could not start the meeting. Please try again.',
    outOfCredits: 'Out of credits. An administrator can raise the limit.',
    invitees: 'Participants',
    noInvitees: 'No invitees',
    editNotice: 'Invitees are not sent a new calendar invitation when the time changes.',
  },
  create: {
    title: 'New meeting',
    subtitle: '{{range}}',
    name: 'Title',
    namePlaceholder: 'Meeting',
    defaultTitle: 'Meeting',
    start: 'Start',
    end: 'End',
    invitees: 'Invite',
    inviteesHint: 'You are always included.',
    language: 'Meeting language',
    languageSv: 'Swedish',
    languageEn: 'English',
    hubMeeting: 'HUB video meeting',
    hubMeetingHint: 'Video, live transcription and meeting notes inside HUB.',
    externalUrl: 'Meeting link (optional)',
    externalUrlPlaceholder: 'https://meet.google.com/...',
    cancel: 'Cancel',
    submit: 'Create meeting',
    submitting: 'Creating…',
    error: 'Could not create the meeting. Please try again.',
    inviteFailures: 'The invitation could not be sent to: {{names}}',
  },
  eventType: {
    meeting: 'Meeting',
    chat: 'Chat',
    document: 'Document',
    whiteboard: 'Whiteboard',
  },
  createForm: {
    title: 'Title',
    titlePlaceholder: 'Meeting title...',
    start: 'Start',
    end: 'End',
    description: 'Description',
    descriptionPlaceholder: 'Optional...',
    create: 'Create',
    close: 'Close',
  },
  quickInvite: {
    title: 'Invite HUB AI to a meeting',
    hint: 'It can take up to 2 minutes before HUB AI joins the meeting.',
    meetingUrl: 'Meeting link',
    urlPlaceholder: 'Paste a Google Meet or Teams link...',
    invalidUrl: 'Enter a valid Google Meet or Teams link',
    googleMeet: '🟢 Google Meet',
    teams: '🔵 Microsoft Teams',
    alreadyActive: 'HUB AI is already in this meeting',
    joining: 'HUB AI is joining the meeting...',
    error: 'Something went wrong. Please try again.',
    cancel: 'Cancel',
    connecting: 'Joining...',
    invite: 'Invite',
  },
  detail: {
    notFound: 'Meeting not found.',
    syncing: 'Syncing meeting...',
    back: 'Back to calendar',
    edit: 'Edit',
    delete: 'Delete meeting',
    cancelled: 'This meeting has been cancelled.',
    title: 'Title',
    start: 'Start',
    end: 'End',
    meetingUrl: 'Meeting link',
    meetingUrlPlaceholder: 'https://meet.google.com/...',
    description: 'Description',
    descriptionPlaceholder: 'Add a description...',
    save: 'Save',
    cancel: 'Cancel',
    noDescription: 'No description.',
  },
  notes: {
    title: 'Meeting notes',
    generating: 'Generating...',
    generate: 'Generate',
    regenerate: 'Regenerate',
    open: 'Open meeting notes',
    empty: 'No meeting notes have been generated yet.',
    noTranscript: 'No transcript is available for this meeting.',
    error: 'Could not generate meeting notes.',
  },
  status: {
    scheduled: 'Scheduled',
    staged: 'Staged',
    ready: 'Ready',
    joining: 'Joining',
    waiting_room: 'In the waiting room',
    joined_not_recording: 'Joined – not recording',
    joined_recording: 'Recording',
    joined_recording_paused: 'Recording paused',
    leaving: 'Leaving',
    post_processing: 'Processing recording',
    ended: 'Ended',
    fatal_error: 'Error',
    cancelled: 'Cancelled',
    data_deleted: 'Data deleted',
    unknown: 'Unknown',
  },
}

export default meetings
